import { render } from "./viewMode-list.svg?vue&type=template&id=b288b942"
const script = {}
script.render = render

export default script